export default __webpack_public_path__ + "static/media/KHMEROSSIEMREAP.c7829629.TTF";